/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

export const getCurrentKioskId = (state) => get(state, ['currentKiosk', 'items']);

export const getCurrentKiosk = (state) => {
    return get(state, ['currentKiosk', 'items'], []);
};

export const requestingCurrentKiosk = (state) => get(state, ['currentKiosk', 'requesting'], false);

export const errorRequestingCurrentKiosk = (state) => get(state, ['currentKiosk', 'error'], false);

export const hasScheduledChanges = createSelector(
    getCurrentKiosk,
    (currentKiosk) => {
        return get(currentKiosk, ['has_scheduled_changes'], false);
    },
);
export const getCurrentKioskPlanId = createSelector(
    getCurrentKiosk,
    (currentKiosk) => {
        return get(currentKiosk, ['plan_id'], null);
    },
);